import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Seo } from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(phone, password);
      toast.success("Berhasil masuk");
      if (user.role === "driver") navigate("/dashboard-driver");
      else if (user.role === "admin" || user.role === "super_admin") navigate("/dashboard-admin");
      else navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Seo title="Masuk | Travele" description="Masuk ke akun Travele dengan nomor WhatsApp terdaftar." noindex />
      <div className="w-full max-w-md border border-border bg-card p-8">
        <Link to="/" className="mb-6 flex items-center">
          <img src="/travele-wordmark.png" alt="Travele" className="h-9 w-auto" />
        </Link>
        <h1 className="font-display text-2xl font-bold">Masuk</h1>
        <p className="mb-6 text-sm text-muted-foreground">Gunakan nomor WhatsApp terdaftar.</p>
        <form onSubmit={submit} className="grid gap-4">
          <div className="grid gap-1.5">
            <Label>Nomor WhatsApp</Label>
            <Input data-testid="login-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="08xxxx" />
          </div>
          <div className="grid gap-1.5">
            <Label>Kata Sandi</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="bg-primary font-bold text-primary-foreground hover:bg-primary/90">
            {loading ? "Memproses..." : "Masuk"}
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Belum punya akun? <Link to="/daftar" className="text-primary hover:underline">Daftar Driver</Link>
        </p>
      </div>
    </div>
  );
}
